module.exports = __webpack_public_path__ + "img/909376b.jpg";